///////////////////////////  HR /////////////////////////////

exports.HR = () => {
  return process.env.VUE_APP_APP_URL;
};

exports.identity = () => {
  return process.env.VUE_APP_IDENTITY;
};

exports.mTop = () => {
  return process.env.VUE_APP_MTOP;
};

// exports.HR = () => {
//   return "https://nanosoft-hr-ekmd8.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://identity-bjag3.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/";
// };

///////////////////////////  pwct /الاشغال العامة ///////////////////////////////////////

// exports.HR = () => {
//   return "https://pwct-hr-6dwb8.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://pwct-identity-rc99b.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/esdf/hr/CompanyLogo/";
// };

///////////////////////////  esdf /الصندوق ///////////////////////////////////////

// exports.HR = () => {
//   return "https://esdf-hr-6dwb8.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://esdf-identity-rc99b.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/esdf/hr/CompanyLogo/";
// };

///////////////////////////  tpb /  المشروعات  ////////////////////////////////

// exports.HR = () => {
//   return "https://tpb-erp-hr-32ue3.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://tpb-erp-identity-k74ir.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/tpb/hr/CompanyLogo/";
// };

///////////////////////////  raba / المصلحة  ////////////////////////////////

// exports.HR = () => {
//   return "https://seashell-app-kbwwj.ondigitalocean.app"; // raba-hr
// };
// exports.identity = () => {
//   return "https://erp-raba-identity-7cwg4.ondigitalocean.app/connect/token"; /// raba-hr
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/raba/hr/CompanyLogo/";
// };

///////////////////////////  lcma  ////////////////////////////////

// exports.HR = () => {
//   return "https://lcma-hr-9lm7g.ondigitalocean.app"; /// new lcma
// };
// exports.identity = () => {
//   return "https://lcma-identity-cbrit.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/lcma/hr/CompanyLogo/";
// };

///////////////////////////  alalama-hr /////////////////////////////////////

// exports.HR = () => {
//   return "https://alalama-hr-ekmd8.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://identity-bjag3.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/";
// };

///////////////////////////  alalama-ss //////////////////////////////////

// exports.HR = () => {
//   return "https://alalama-ss-ekmd8.ondigitalocean.app";
// };
// exports.identity = () => {
//   return "https://identity-bjag3.ondigitalocean.app/connect/token";
// };

// exports.mTop = () => {
//   return "https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/";
// };

exports.NULL = (item) => {
  if (item == null || item == "null") {
    return "";
  } else {
    return item;
  }
};

// "node-sass": "^4.13.1",
// "@vue/cli-plugin-eslint": "4.2.3",
//  gh auth login
